var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"warning-container"},[_c('div',{staticClass:"warning-text"},[_c('IconWarningAmber',{attrs:{"color":"#fa8425"}}),_vm._v(" "),_c('strong',[_vm._v("Aviso:")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }